import { Box, Stack } from "@mui/material";
import { CheckboxInput } from "Components/Shared/Inputs/Form/CheckboxInput";
import { CountryDropdown } from "Components/Shared/Inputs/Form/Dropdowns/CountryDropdown";
import { FormInput } from "Components/Shared/Inputs/Form/FormInput";
import { AverageTransactionValueDropdown } from "Components/Shared/SelectorsForm/AverageTransactionValueDropdown";
import { BusinessActivityDropdown } from "Components/Shared/SelectorsForm/BusinessActivityDropdown";
import { ExpectedMonthlyRevenueDropdown } from "Components/Shared/SelectorsForm/ExpectedMonthlyRevenueDropdown";
import { IncomeSourceCheckboxGroup } from "Components/Shared/SelectorsForm/IncomeSourceCheckboxGroup";
import type { VerificationFormFieldsProps as Props } from "Components/UserAccount/Shared/VerificationForm/types";
import { BusinessActivity, SourceOfIncome } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.Verification.Form.Fields; //TODO: share translations better

export const SelfEmployedVerificationFormFields = ({
  control,
  watch,
}: Props) => {
  const { t } = useResource();
  const businessActivity = watch("businessActivity");
  const sourcesOfIncome = watch("sourcesOfIncome");

  return (
    <Box component="fieldset" sx={{ all: "unset", display: "grid" }}>
      <CountryDropdown
        control={control}
        name="taxResidency"
        label={t(COMPONENT_RESOURCES.TaxResidencyCountryID)}
        isDisabled
      />
      <BusinessActivityDropdown
        control={control}
        name="businessActivity"
        label={t(COMPONENT_RESOURCES.BusinessActivity)}
        includeLegacy
      />
      {businessActivity === BusinessActivity.OtherAndPublicServices && (
        <FormInput
          control={control}
          name="otherBusinessActivityDetails"
          label={t(COMPONENT_RESOURCES.OtherBusinessActivityDetails)}
        />
      )}
      <IncomeSourceCheckboxGroup
        control={control}
        name="sourcesOfIncome"
        label={t(COMPONENT_RESOURCES.SourceOfIncome)}
      />
      {sourcesOfIncome?.includes(SourceOfIncome.OtherBusinessIncome) && (
        <FormInput
          control={control}
          name="otherSourceOfIncomeDetails"
          label={t(COMPONENT_RESOURCES.OtherSourceOfIncomeDetails)}
        />
      )}
      <ExpectedMonthlyRevenueDropdown
        control={control}
        name="expectedMonthlyRevenue"
        label={t(COMPONENT_RESOURCES.ExpectedMonthlyRevenue)}
      />
      <AverageTransactionValueDropdown
        control={control}
        name="averageTransactionValue"
        label={t(COMPONENT_RESOURCES.AverageTransactionValue)}
      />
      <Stack gap={1} mb="1rem">
        <CheckboxInput
          control={control}
          name="isPoliticallyExposedPerson"
          label={t(COMPONENT_RESOURCES.IsPoliticallyExposedPerson)}
          disabled
        />
        <CheckboxInput
          label={t(COMPONENT_RESOURCES.HasNonEUResidence)}
          control={control}
          name="hasNonEUResidence"
          disabled
        />
        <CheckboxInput
          label={t(COMPONENT_RESOURCES.HasNonEUNationality)}
          control={control}
          name="hasNonEUNationality"
          disabled
        />
      </Stack>
    </Box>
  );
};
